import "bootstrap/dist/js/bootstrap.js";
import Alpine from 'alpinejs'
import Header from './components/header.js'
import BlogHeader from './components/blog-header.js'
import PageContentStack from './components/page-content-stack.js'
import CommonStore from './stores/common-store.js'
 
window.Alpine = Alpine
Alpine.store( 'commonStore', CommonStore );
Alpine.data( 'header', Header );
Alpine.data( 'blogHeader', BlogHeader );
Alpine.data( 'pcsData', PageContentStack );
Alpine.start()


var navbar = document.getElementById( 'headerMain' );
if( navbar ){
    window.onscroll = function() {
        // pageYOffset or scrollY
        if ( window.pageYOffset > 0 ) {
            navbar.classList.add( 'scrolled' );
        } else {
            navbar.classList.remove('scrolled');
        }
    };
}
